function validPath(name) {
	if (name === ".") {
		return true;
	}
	while (name.length > 0) {
		const separatorIndex = name.indexOf("/");
		const elem = separatorIndex === -1 ? name : name.substring(0, separatorIndex);
		if (elem === "" || elem === "." || elem === "..") {
			return false;
		}
		if (separatorIndex === -1) {
			return true;
		}
		name = name.substring(separatorIndex + 1);
	}
	return true;
}
class LazyPathBuffer {
	constructor(s) {
		this.writeIndex = 0;
		this.path = s;
	}
	index(i) {
		return this.buffer ? this.buffer[i] : this.path[i];
	}
	append(c) {
		if (!this.buffer) {
			if (this.writeIndex < this.path.length && this.path[this.writeIndex] === c) {
				this.writeIndex++;
				return;
			}
			this.buffer = Array.from(this.path);
		}
		this.buffer[this.writeIndex] = c;
		this.writeIndex++;
	}
	string() {
		if (!this.buffer) {
			return this.path.substring(0, this.writeIndex);
		}
		return this.buffer.slice(0, this.writeIndex).join("");
	}
}
class LazyVolPathBuffer extends LazyPathBuffer {
	constructor(options) {
		super(options.path);
		this.originalPath = options.originalPath;
		this.volLen = options.volLen;
	}
	prepend(...prefix) {
		if (!this.buffer) {
			this.buffer = Array.from(this.path);
		}
		this.buffer = [...prefix, ...this.buffer];
		this.writeIndex += prefix.length;
	}
	string() {
		if (!this.buffer) {
			return this.originalPath.substring(0, this.volLen + this.writeIndex);
		}
		return this.originalPath.substring(0, this.volLen) + this.buffer.slice(0, this.writeIndex).join("");
	}
}

export { LazyPathBuffer, LazyVolPathBuffer, validPath };
//# sourceMappingURL=shared.js.map
